export function getCurrentMonth() {
    const FLAG = 5
    const d = new Date()
    const y = d.getFullYear()
    let m = d.getMonth() 
    const day = d.getDate() + 1
    let range = ''
    //  每月5号前，默认显示上月的数据
    if (d.getMonth() === 0 && day <= FLAG) {
        range = `${y - 1}/${12}`
      } else if (day <= FLAG) {
        m = m < 10 ? "0" + m : m
        range = `${y}/${m}`

      }else {
          m = m+1
          m = m < 10 ? "0" + m : m
          range = `${y}/${m}`
      }
    return {
        begin_time:range,
        end_time:range,
    }
}

export function convertFormat(date) {
   return date.replace(/\//g,'-') || ''
}

export function getMonthRanges() {
    var FLAG = 3
      var d = new Date();
      var y = d.getFullYear()
      var m = d.getMonth()
      var day = d.getDate() + 1
      const date = {}
      //  每月5号前，默认显示上月的数据
      if (d.getMonth() === 0 && day <= FLAG) {
        date.begin_time =date.end_time = `${y - 1}/${12}`
      } else if (day <= FLAG) {
        m = m < 10 ? "0" + m : m
        date.begin_time = date.end_time = `${y}/${m}`

      } else {
        m = m + 1
        m = m < 10 ? "0" + m : m
        date.begin_time = date.end_time = `${y}/${m}`
      }
      return date
 }


// WEBPACK FOOTER //
// ./src/assets/js/date.js